import { Component, ChangeDetectionStrategy, OnInit } from '@angular/core';

import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { NgxPermissionsService } from 'ngx-permissions';

import * as fromStore from './../../store';
import { User } from '../../../../models/user.interface';
import { Organization } from '../../../../models/organization.interface';
import { ActivatedRoute } from '@angular/router';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'alii-web-organisation',
    templateUrl: './organisation.component.html'
})
export class OrganisationComponent implements OnInit {
    teamId: string;
    users$: Observable<User[]>;
    organization$: Observable<Organization>;
    name: string;

    constructor(
        private store: Store<fromStore.OrganisationsFeatureState>,
        private permissionsService: NgxPermissionsService,
        private route: ActivatedRoute
        ) {
        this.route.paramMap.subscribe(params => {
            this.teamId = params.get('id');
        });
        }

    ngOnInit() {
        this.store.dispatch(new fromStore.LoadUsers(this.teamId));
        this.store.dispatch(new fromStore.LoadOrganization());
        this.users$ = this.store.select(fromStore.getUsers);
        this.organization$ = this.store.select(fromStore.getOrganization);

        this.organization$.subscribe(organization => {
            if (organization) {
                this.name = organization.name;
                if (organization.roles) {
                    const roles = organization.roles.reduce((acc, rl: any) => {
                        return [...acc, rl.role];
                    }, []);
                    this.permissionsService.addPermission(roles);
                }
            }
        });
    }

    handleEventBus(event) {
        const { action, payload } = event;
        switch (action) {
            case 'removeUser':
                this.handleRemoveUser(payload);
                break;
            case 'setAdmin':
                this.handleSetAdmin(payload);
                break;
            case 'setStatistics':
                this.handleSetStatistics(payload);
                break;
            case 'removeStatistics':
                this.handleRemoveStatistics(payload);
                break;
            case 'setReviewer':
                this.handleSetReviewer(payload);
                break;
            case 'removeReviewer':
                this.handleRemoveReviewer(payload);
                break;
            default:
                break;
        }
    }
    handleRemoveUser(payload) {
        const { userId } = payload;
        this.store.dispatch(new fromStore.RemoveUser({ userId }));
    }

    handleSetAdmin(payload) {
        const { userId } = payload;
        this.store.dispatch(new fromStore.SetAdmin({ userId }));
    }

    handleSetStatistics(payload) {
        const { userId } = payload;
        this.store.dispatch(new fromStore.SetStatistics({ userId }));
    }

    handleRemoveStatistics(payload) {
        const { userId } = payload;
        this.store.dispatch(new fromStore.RemoveStatistics({ userId }));
    }

    handleSetReviewer(payload) {
        const { userId } = payload;
        this.store.dispatch(new fromStore.SetReviewer({ userId }));
    }

    handleRemoveReviewer(payload) {
        const { userId } = payload;
        this.store.dispatch(new fromStore.RemoveReviewer({ userId }));
    }
}
